import {Component, OnInit} from '@angular/core';
import {GlobalService} from '../../../service/global.service';
import {ModalService} from '../../../service/modal.service';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {CatalogoApiService} from '../../../service/api/catalogo.api';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {JQueryStatic} from 'jquery';


declare var $: JQueryStatic;

@Component({
    selector: 'confirmar-fta-modal',
    templateUrl: './confirmar-fta-modal.component.html',
    styleUrls: ['./confirmar-fta-modal.component.css']
})
export class ConfirmarFtaModalComponent implements OnInit {

    constructor(
        private globalService: GlobalService,
        public modalService: ModalService,
        public pesquisaService: PesquisasFiltroApiService,
        public catalogoApi: CatalogoApiService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute) {
    }

    sub: any;
    codFTA: any;
    vrsFTA: any;
    visiveis: any;
    resultado: any;
    totalPaginas: any;
    qtdPorPagina: any;
    msg: string;
    loading: any;
    msgHistoricoInclusaoFta: string;
    mensagemErro: string;
    versao: string;

    ngOnInit() {

    }


    salvarFta(versao) {

        if (this.msgHistoricoInclusaoFta) {
            this.versao = versao;
            this.modalService.incluirDadosGerados({msgHistoricoInclusaoFta: this.msgHistoricoInclusaoFta, versao});
            this.modalService.fecharPaginaModal();
            return;
        } else {
            this.mensagemErro = 'Informe a justificativa';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/modal/confirmar-fta-modal/confirmar-fta-modal.component.ts